// extracted by mini-css-extract-plugin
export default {"header":"header__ZDcxY","content":"content__Y2Y3N"};